




















import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import CreateCate from './create-cate.vue'
import EditCate from './edit-cate.vue'
class  PageCateRequest extends PageRequest{
    name:string;
}

@Component({
    components:{CreateCate,EditCate}
})
export default class Cates extends AbpBase{
    edit(){
        this.editModalShow=true;
    }
    //filters
    pagerequest:PageCateRequest=new PageCateRequest();

    createModalShow:boolean=false;
    editModalShow:boolean=false;

    get list(){
        return this.$store.state.articleCategory.list;
    };
    get loading(){
        return this.$store.state.articleCategory.loading;
    }
    create(){
        this.createModalShow=true;
    }
    
    pageChange(page:number){
        this.$store.commit('articleCategory/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('articleCategory/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){
      
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        //filters
        

        await this.$store.dispatch({
            type:'articleCategory/getAll',
            data:this.pagerequest
        })
    }
    get pageSize(){
        return this.$store.state.articleCategory.pageSize;
    }
    get totalCount(){
        return this.$store.state.articleCategory.totalCount;
    }
    get currentPage(){
        return this.$store.state.articleCategory.currentPage;
    }
    columns=[{
        title:this.L('CategoryName'),
        key:'name'
    },{
        title:this.L('ShowOnHome'),
        render:(h:any,params:any)=>{
           return h('span',params.row.showOnHome?this.L('Yes'):this.L('No'))
        }
    },{
        title:this.L('ShowInMainMenu'),
        render:(h:any,params:any)=>{
           return h('span',params.row.showInMainMenu?this.L('Yes'):this.L('No'))
        }
    },{
        title: this.L("ShowOrder"),
        key: 'order'
    },{
        title:this.L('CreationTime'),
        key:'creationTime',
        render:(h:any,params:any)=>{
            return h('span',new Date(params.row.creationTime).toLocaleDateString())
        }
    },{
        title:this.L('Actions'),
        key:'Actions',
        width:150,
        render:(h:any,params:any)=>{
            return h('div',[
                h('Button',{
                    props:{
                        type:'primary',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.$store.commit('articleCategory/edit',params.row);
                            this.edit();
                        }
                    }
                },this.L('Edit')),
                h('Button',{
                    props:{
                        type:'error',
                        size:'small'
                    },
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title:this.L('Tips'),
                                    content:this.L('ArticleCategoryDeleteWarningMessage'),
                                    okText:this.L('Yes'),
                                    cancelText:this.L('No'),
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'articleCategory/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },this.L('Delete'))
            ])
        }
    }]
    async created(){
        this.getpage();
    }
}
